// Метка «исполнитель/статус получены из TMS сверкой, а не внесены в ERP» для карточки рейса.
// Показываем, только пока в рейсе стоит именно тот исполнитель, которого принесла сверка:
// если логист потом назначит другого в ERP — метка исчезает сама.

function pad(n) {
  return String(n).padStart(2, '0')
}

export function formatSyncDate(value) {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function syncActorLabel(by) {
  if (!by) return 'сверка с TMS'
  if (by === 'auto-resync') return 'авто-сверка с TMS (без участия человека)'
  return 'сверка с TMS по кнопке «Resync»'
}

export function tmsSyncInfo(trip, executor) {
  if (!trip || !executor || trip.tms_synced_executor_id == null) return null
  if (Number(trip.tms_synced_executor_id) !== Number(executor.id)) return null
  const at = formatSyncDate(trip.tms_synced_at)
  const status = trip.tms_synced_status ? ` и статус («${trip.tms_synced_status}» в TMS)` : ''
  return {
    title: 'Получено из TMS, а не через ERP',
    text: `Исполнитель${status} пришли из TMS автоматически${at ? ' ' + at : ''} — в ERP вручную не вносились.`,
    who: syncActorLabel(trip.tms_synced_by),
    logLink: `/admin/tms-action-log?trip_id=${encodeURIComponent(trip.trip_id || trip.id)}`,
  }
}
